import { CommonConstants, DirectBillingConstants } from "../../constants";
import { BillingApiCaller } from "../../middlewares/BillingApiCaller";
import { store } from "../../store";
import { showError } from "../commonActions";

export const deleteDirectBilling = async () => {
  try {
    const response = await BillingApiCaller.deleteBilling();
    store.dispatch({
      type: DirectBillingConstants.DELETE_DIRECTBILLING,
      payload: response
    });
  } catch (error) {
    error && showError(error);
  }

  return {
    type: CommonConstants.NO_CHANGE
  };
};
